import React from "react";
import { aetna, cigna, carefirst, optum, united } from "../assets";

const Insurance = [
  { src: aetna, alt: "Aetna" },
  { src: cigna, alt: "CIGNA" },
  { src: carefirst, alt: "CArefirst" },
  { src: optum, alt: "Optum" },
  { src: united, alt: "United" },
  // { src: java, alt: "Java" },
  // { src: devops, alt: "DevOps" },
  // { src: postgres, alt: "PostgreSQL" },
  // { src: mysql, alt: "MySQL" },
  // { src: mongodb, alt: "MongoDB" },
  // { src: bash, alt: "Bash" },
  // { src: github, alt: "GitHub" },
  // { src: jenkins, alt: "Jenkins" },
  // { src: nmap, alt: "Nmap" },
  // { src: wireshark, alt: "Wireshark" },
  // { src: oracle, alt: "Oracle" },
  // { src: docker, alt: "Docker" },
  // { src: nginx, alt: "NGINX" },
  // { src: caddy, alt: "Caddy" },
  // { src: grafana, alt: "Grafana" },
  // { src: kubernetes, alt: "Kubernetes" },
  // { src: gitlab, alt: "GitLab" },
  // { src: bitbucket, alt: "Bitbucket" },
];

function Partner() {
  return (
    <div className="py-16 md:py-20 lg:py-24 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-block px-4 py-2 bg-primary-100 rounded-full mb-4">
            <span className="text-primary-700 font-semibold text-body-sm">Insurance Partners</span>
          </div>
          <h2 className="text-heading-xl md:text-display-sm text-neutral-900 mb-4">
            We Accept Major Insurance Plans
          </h2>
          <p className="text-body-lg text-neutral-600 max-w-2xl mx-auto leading-relaxed">
            We accept most insurance providers including Medicaid and Medicare.
            Contact us if you have any questions regarding your coverage.
          </p>
        </div>

        <div className="relative overflow-hidden">
          <div className="inline-flex w-full flex-nowrap overflow-hidden bg-white rounded-xl shadow-soft py-10 border border-neutral-100 [mask-image:linear-gradient(to_right,transparent_0,black_128px,black_calc(100%-128px),transparent_100%)]">
            <ul className="flex items-center justify-center md:justify-start animate-infinite-scroll">
              {Insurance.map((tech, index) => (
                <li key={index} className="flex items-center justify-center flex-shrink-0 w-40 md:w-48 h-20 md:h-24 mx-8 md:mx-10">
                  <img
                    src={tech.src}
                    alt={tech.alt}
                    className="max-h-full max-w-full w-auto h-auto object-contain opacity-80 hover:opacity-100 transition-opacity duration-300"
                  />
                </li>
              ))}
            </ul>
            <ul className="flex items-center justify-center md:justify-start animate-infinite-scroll" aria-hidden="true">
              {Insurance.map((tech, index) => (
                <li key={index} className="flex items-center justify-center flex-shrink-0 w-40 md:w-48 h-20 md:h-24 mx-8 md:mx-10">
                  <img
                    src={tech.src}
                    alt={tech.alt}
                    className="max-h-full max-w-full w-auto h-auto object-contain opacity-80 hover:opacity-100 transition-opacity duration-300"
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="text-center mt-10">
          <p className="text-body-md text-neutral-500">
            Don't see your insurance provider?{" "}
            <a href="/contact" className="text-primary-600 hover:text-primary-700 font-semibold transition-colors">
              Contact us
            </a>
            {" "}to verify coverage
          </p>
        </div>
      </div>
    </div>
  );
}

export default Partner;
